import { useSession } from 'next-auth/react';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const sendDevice = async (url: string, data: CustomerDeviceCodeProps) =>
  await api.post(url, data);

export const useSendDevice = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.customer.sendDevice
      : apiConfig.routes.customer.sendDevicePublic;

  return useMutation({
    mutationFn: (data: CustomerDeviceCodeProps) => sendDevice(url, data),
  });
};

type CustomerDeviceCodeProps = {
  device_code: string;
  type: string;
  agent: string;
  device_ip?: string;
  state?: string;
  city?: string;
  country?: string;
};
